import type { IssuableStudent, IssuanceRejectionReasonCode } from "./types";

// 申込 URL の発行で出す文言。エラー文言は仕様書 No.2 の「エラー文言」の表で PdM が確定したもの（2026-10-09）。
// ワイヤーにある文言（選べない理由・完了メッセージ）はワイヤーのとおり。変えるときはこのファイルだけを直す
// 2026-10-14 に「学習管理プラン」を「学習管理サービス」にそろえた（plan_inactive と選べない理由の 2 件。WEB-2815。経緯は proposal）

export const ISSUANCE_SUCCEEDED_MESSAGE = "申込URLを発行しました";

export const NO_COURSE_MESSAGE =
  "この校舎では申込URLを発行できません。営業担当にお問い合わせください。";
export const COURSES_FETCH_FAILED_MESSAGE =
  "コースを取得できませんでした。時間をおいて再度お試しください。";
export const NO_STUDENT_FOUND_MESSAGE = "該当する生徒が見つかりません。";
export const STUDENT_SEARCH_FAILED_MESSAGE =
  "生徒を検索できませんでした。時間をおいて再度お試しください。";

const NO_LONGER_ISSUABLE_MESSAGE =
  "この校舎では申込URLを発行できなくなりました。営業担当にお問い合わせください。";

export const STUDENT_NOT_ISSUABLE_MESSAGE =
  "選択した生徒には申込URLを発行できません。生徒の登録状況をご確認ください。";

const REJECTION_MESSAGES: Record<IssuanceRejectionReasonCode, string> = {
  corporation_not_linked: NO_LONGER_ISSUABLE_MESSAGE,
  no_active_course: NO_LONGER_ISSUABLE_MESSAGE,
  student_not_found: STUDENT_NOT_ISSUABLE_MESSAGE,
  student_active_contract_exists:
    "選択した生徒には有効な契約があるため、申込URLを発行できません。",
  plan_inactive:
    "選択した生徒は学習管理サービスがOFFのため、申込URLを発行できません。",
};

export const ISSUANCE_FORBIDDEN_MESSAGE =
  "この校舎では申込URLを発行できなくなりました。";
export const ISSUANCE_TIMEOUT_MESSAGE =
  "発行できたかを確認できませんでした。申込一覧を確認してから、必要であればもう一度発行してください。";
export const ISSUANCE_FAILED_MESSAGE =
  "申込URLを発行できませんでした。時間をおいて再度お試しください。";

export const toRejectionMessage = (
  reasonCode: IssuanceRejectionReasonCode,
): string => REJECTION_MESSAGES[reasonCode] ?? ISSUANCE_FAILED_MESSAGE;

// 検索結果で選べない理由（ワイヤー 2-A のとおり）
const UNSELECTABLE_REASON_LABELS: Record<
  NonNullable<IssuableStudent["unselectableReason"]>,
  string
> = {
  active_contract_exists: "有効な契約があるため選択不可",
  learning_management_not_contracted: "学習管理サービスOFFのため選択不可",
};

export const toUnselectableReasonLabel = (
  reason: IssuableStudent["unselectableReason"],
): string => (reason ? UNSELECTABLE_REASON_LABELS[reason] : "選択不可");
